
import { Link } from 'react-router-dom';
import { getHero } from '../../../api/apiServices';
import { useEffect } from 'react';

export default function HeroSection() {
  const [backgroundFile, setBackgroundFile] = useState(null);
  const [hero, setHero] = useState([])
  const [isSaving, setIsSaving] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  
     useEffect(() => {
      const fetchHero = async () => {
        try {
          const res = await getHero();
          if (res?.data) {
            setHero(res.data);
          }
        } catch {
          console.log("")
        }
      };
      fetchHero();
    }, []);

  return (
    <section className="min-h-[600px] md:min-h-[700px] w-full overflow-hidden relative">
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-transparent"></div>
      <img
        src={hero.image}
        alt="SISI Fashion Collection"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="relative z-10 flex items-center h-full min-h-[600px] md:min-h-[700px] pt-20">
        <div className="w-full max-w-[1200px] mx-auto px-6">
          <div className="max-w-xl">
            <h2 className="text-4xl md:text-6xl font-['Playfair_Display'] font-bold text-white mb-6 leading-tight">
              {hero.title}
            </h2>
            <p className="text-white/90 font-['Poppins'] text-base md:text-lg mb-8 leading-relaxed">
              {hero.subtitle}
            </p>
            <div className="flex flex-wrap gap-4">
              <Link 
                to="/products" 
                className="px-8 py-3.5 bg-[#EF579A] text-white rounded-full font-['Poppins'] font-medium hover:bg-[#d94a87] transition-colors whitespace-nowrap cursor-pointer"
              >
                {hero.buttonText}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
